type RoutePreloadTarget =
  | 'auth'
  | 'bookingChoice'
  | 'bookingFlow'
  | 'dashboard'
  | 'practitionerList'
  | 'practitionerProfile'
  | 'serviceSelection';

const routePreloaders: Record<RoutePreloadTarget, () => Promise<unknown>> = {
  auth: () => import('@/pages/ClientAuth'),
  bookingChoice: () => import('@/pages/BookingChoice'),
  bookingFlow: () => import('@/pages/BookingDateTime'),
  dashboard: () => import('@/pages/ClientDashboard'),
  practitionerList: () => import('@/pages/Practitioners'),
  practitionerProfile: () => import('@/components/practitioners/PractitionerDetail'),
  serviceSelection: () => import('@/pages/ServiceSelection'),
};

export function preloadRoute(target: RoutePreloadTarget) {
  void routePreloaders[target]?.();
}

export function preloadRouteForPath(path: string) {
  if (path.startsWith('/client-dashboard')) return preloadRoute('dashboard');
  if (path.startsWith('/client-auth') || path.startsWith('/signup')) return preloadRoute('auth');
  if (path.startsWith('/booking-datetime')) return preloadRoute('bookingFlow');
  if (path.startsWith('/booking-choice')) return preloadRoute('bookingChoice');
  if (path.startsWith('/service-selection')) return preloadRoute('serviceSelection');
  if (path.startsWith('/book-an-appointment/')) return preloadRoute('practitionerProfile');
  if (path.startsWith('/book-an-appointment')) return preloadRoute('practitionerList');
}

export function preloadCoreConversionRoutes() {
  const run = () => {
    preloadRoute('auth');
    preloadRoute('bookingChoice');
    preloadRoute('practitionerProfile');
    preloadRoute('bookingFlow');
    preloadRoute('dashboard');
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(run, { timeout: 2500 });
  } else {
    globalThis.setTimeout(run, 1200);
  }
}